import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import Swal from 'sweetalert2';
import Moment from 'moment';
import 'moment/locale/es';
import { Link } from 'react-router-dom';
import { getContadores } from '../../../services/contadores/contadoresService';
import { lenguage, optionsTable, tableIcons } from "../../structure/config-datatable";
import { ContadoresEditModal } from './edit-modal/ContadoresEditModal';

export const DatatableContadores = () => {
    const [state, setState] = useState([]);
    const [modalEditar, setModalEditar] = useState(false);
    const [edit, setEdit] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    // Cargar contadores
    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const data = await getContadores();
                setState(data);
            } catch (error) {
                console.log('Error fetching contadores:', error);
                Swal.fire('Error', 'Error al cargar contadores', 'error');
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);

    // Acciones de la tabla
    const acciones = [
        {
            icon: () => <tableIcons.Edit style={{ color: "#FFC007" }} />,
            tooltip: 'Editar',
            onClick: (e, rowData) => {
                setEdit({
                    id: rowData.id,
                    nombrerazonsocial: rowData.nombrerazonsocial,
                    cedula: rowData.cedula,
                    telefono: rowData.telefono,
                    email: rowData.email,
                    estado: rowData.estado,
                    tipo_membresia: rowData.tipo_membresia,
                    fecha_vencimiento: rowData.fecha_vencimiento,
                    cantidad_clientes: rowData.cantidad_clientes,
                    cantidad_auxiliares: rowData.cantidad_auxiliares
                });
                setModalEditar(true);
            }
        }
    ];

    // Columnas de la tabla
    const columnas = [
        {
            title: "Razón Social",
            field: "nombrerazonsocial",
            width: "25%"
        },
        {
            title: "Cédula",
            field: "cedula",
        },
        {
            title: "Teléfono",
            field: "telefono",
        },
        {
            title: "Email",
            field: "email",
        },
        {
            title: "Tipo de Membresía",
            field: "tipo_membresia",
        },
        {
            title: "Fecha Vencimiento",
            field: "fecha_vencimiento",
            render: rowData =>
                rowData.fecha_vencimiento !== undefined ?
                    Moment(rowData.fecha_vencimiento).format("D MMM YYYY")
                    : ""
        },
        {
            title: "Clientes",
            field: "cantidad_clientes",
            type: "numeric",
            width: "10%",
            render: rowData => (
                <Link
                    to={`/dashboard/clientes/${rowData.id}`}
                    style={{
                        color: "#007bff",
                        textDecoration: "none",
                        fontWeight: "bold",
                        cursor: "pointer"
                    }}
                    onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                    onMouseLeave={(e) => e.target.style.textDecoration = "none"}
                >
                    {rowData.cantidad_clientes}
                </Link>
            )
        },
        {
            title: "Auxiliares",
            field: "cantidad_auxiliares",
            type: "numeric",
            width: "10%",
            render: rowData => (
                <Link
                    to={`/dashboard/auxiliares/${rowData.id}`}
                    style={{
                        color: "#007bff",
                        textDecoration: "none",
                        fontWeight: "bold",
                        cursor: "pointer"
                    }}
                    onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                    onMouseLeave={(e) => e.target.style.textDecoration = "none"}
                >
                    {rowData.cantidad_auxiliares}
                </Link>
            )
        },
        {
            title: "Estado",
            field: "estado",
            width: "10%",
            render: rowData => (
                <span className="badge" style={{
                    backgroundColor: rowData.estado === 1 ? "#28a745" : "#dc3545",
                    color: "white",
                    padding: "5px 10px",
                    borderRadius: "4px",
                    fontWeight: "bold"
                }}>
                    {rowData.estado === 1 ? "Activo" : "Inactivo"}
                </span>
            )
        }
    ];

    // Recargar tabla después de editar
    const handleReload = async () => {
        const data = await getContadores();
        setState(data);
    };

    return (
        <>
            {!isLoading ? (
                <div className="card-body">
                    <MaterialTable
                        icons={tableIcons}
                        columns={columnas}
                        data={state}
                        title={""}
                        options={optionsTable}
                        localization={lenguage}
                        actions={acciones}
                    />
                    <ContadoresEditModal
                        setModalEditar={setModalEditar}
                        modalEditar={modalEditar}
                        editar={edit}
                        onReload={handleReload}
                    />
                </div>
            ) : (
                <div
                    className="card-body"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "400px",
                    }}
                >
                    <div className="loader-carga"></div>
                </div>
            )}
        </>
    );
};
